<span class="text-shui-text-moderate text-sm font-semibold">
    <ng-content></ng-content>
</span>
@if (filterable()) {
    @if (sortDirection() === SortOrder.ASC) {
        <sh-icon icon="sort-ascending" size="sm" class="text-shs-orange"></sh-icon>
    } @else if (sortDirection() === SortOrder.DESC) {
        <sh-icon icon="sort-descending" size="sm" class="text-shs-orange"></sh-icon>
    } @else {
        <sh-icon icon="sort-by" size="sm" class="text-shs-orange"></sh-icon>
    }
}
